// 心动时刻标题映射
export const ROMANTIC_MOMENT_TITLE_MAP = {
  romantic_moment_1: 'The Hug We Shared',
  romantic_moment_2: 'The Kiss We Shared',
  romantic_moment_3: 'The Wedding We Shared',
} as const

// 奖励代码前缀
export const REWARD_CODE_PREFIX = {
  LETTER_WITH_IMAGE: 'letter_with_image_',
  MEMORY_ALBUM: 'memory_album_',
  MONOLOGUE_SLOT: 'monologue_slot_',
  EVENT_SLOT: 'event_slot_',
  ROMANTIC_MOMENT: 'romantic_moment_',
  TIDAL_HEARTS_VIDEO: 'tidal_hearts_video_',
  PIN_MEMORY: 'pin_memory_',
  GEM_REFUND: 'gem_refund_',
  CALENDAR_SUMMARY: 'calendar_summary_',
} as const

// 关系消息类型
export const RELATIONSHIP_MESSAGE_TYPE = {
  LETTER: 'relationship_letter_with_image',
  MONOLOGUE: 'relationship_monologue_slot',
  EVENT: 'relationship_event_slot',
  ROMANTIC_MOMENT: 'relationship_romantic_moment',
  TIDAL_HEARTS_VIDEO: 'tidal_hearts_video',
  MEMORY_ALBUM: 'relationship_memory_album',
  DREAM: 'relationship_dream_slot',
  MYSTERY_REWARDS: 'mystery_rewards',
  GEM_REFUND: 'relationship_gem_refund',
} as const

// 奖励状态
export const REWARD_STATUS = {
  GRANTED: 'granted', // 已获得
  ACHIEVABLE: 'achievable', // 可领取
  LOCKED: 'locked', // 未解锁
} as const

export const EASTER_CHAT_GIFT_CODES = {
  LUCKY_EGG: 'gift_lucky_egg',
  GOLDEN_EGG: 'gift_golden_egg',
} as const

export const EASTER_CHAT_ACTIVITY_END_TIME = new Date(
  '2026-04-27T00:00:00Z'
).getTime()

export const EASTER_CHAT_GUIDE_DEBUG_MODE: '' | 'golden' | 'lucky' = ''

export const MAY_BALL_FLOWER_GIFT_CODE = 'flower'

export const MAY_BALL_FLOWER_FIRST_SEEN_KEY = 'may_ball_flower_first_seen'

export {
  MAY_BALL_ACTIVITY_START_TIME,
  MAY_BALL_ACTIVITY_END_TIME,
  isMayBallActivityActive,
} from './mayBall'
